/**
 *
 * Any pdf, doc, docx link automatically opens in new tab
 *
 */
export function openDocsInit() {
    const links = document.querySelectorAll('a[href$=".pdf"], a[href$=".doc"], a[href$=".docx"]');
    links.forEach(link => link.setAttribute('target', '_blank'));
}